<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
    v-if="!this.hide"
    >
    
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="javascript:void(0)">
              About Us
            </a>
          </li>
          <li>
            <a href="javascript:void(0)">
              Blog
            </a>
          </li>
          <li>
            <a href="javascript:void(0)">
              Licenses
            </a>
          </li>
          <li>
            <router-link v-bind:to="{ name: 'templates'}">Templates</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, made by <a href="javascript:void(0)" target="_blank">Yarborough Co., Ltd.</a>.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String,
    hide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  methods: {
    
  }
};
</script>
<style></style>
